<h1 mat-dialog-title>
    <span>{{ 'admin.frais.cartes.suivi.anomalieTitle' | translate }} - {{ detailOpeCarte?.idOpeCarte }}</span>
    <span [mat-dialog-close]="false"><i class="zmdi zmdi-close"></i></span>
</h1>
<please-wait *ngIf="isLoading"></please-wait>
<ng-container *ngIf="!isLoading && detailOpeCarte">
    <div *ngIf="alerte" class="page-header error">
        <card-alerte [niveau]="alerte.niveau">
            <preview-alerte [alerte]="alerte"></preview-alerte>
        </card-alerte>
    </div>
    <div mat-dialog-content>
        <form autocomplete="off">
            <row-data [dataGauche]="{ traduction: 'admin.frais.cartes.suivi.reference', valeur: detailOpeCarte.idOpeCarte }"
                      [dataDroite]="{ traduction: 'admin.frais.cartes.suivi.dateDetail', valeur: detailOpeCarte.date | date:'short' }">
            </row-data>
            <row-data [dataGauche]="{ traduction: 'admin.frais.cartes.suivi.carte', valeur: detailOpeCarte.numCarteClair }"
                      [dataDroite]="{ traduction: 'admin.frais.cartes.suivi.enseigne', valeur: detailOpeCarte.enseigne }">
            </row-data>
            <row-data [dataGauche]="{ traduction: 'admin.frais.cartes.suivi.collaborateur', valeur: detailOpeCarte.collab }"
                      [dataDroite]="{ traduction: 'admin.frais.cartes.suivi.localite', valeur: detailOpeCarte.localite }">
            </row-data>
            <row-data [dataGauche]="{ traduction: 'admin.frais.cartes.suivi.matricule', valeur: detailOpeCarte.matricule }"
                      [dataDroite]="{ traduction: 'admin.frais.cartes.suivi.pays', valeur: detailOpeCarte.pays }">
            </row-data>
            <row-data [dataGauche]="{ traduction: 'admin.frais.cartes.suivi.type', valeur: detailOpeCarte.libelleMedoc }"
                      [dataDroite]="{ traduction: 'admin.frais.cartes.suivi.activite', valeur: detailOpeCarte.libelleMcc }">
            </row-data>
            <row-data [dataGauche]="{ traduction: 'admin.frais.cartes.suivi.montant', valeur: (detailOpeCarte.montant | number:'.2-2') + ' ' + detailOpeCarte.devise }">
            </row-data>
        </form>
    </div>
</ng-container>